import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Input, Select, InputDate, RadioGroup, Radio, Checkbox } from 'components/fields'

export default class PersonalDetails extends Component {
  static propTypes = {
    titles: PropTypes.array,
    genders: PropTypes.array,
    nationalities: PropTypes.array,
    employmentStatuses: PropTypes.array,
    errors: PropTypes.object,
    prefix: PropTypes.string,
    isPayment: PropTypes.bool,
    showTitle: PropTypes.bool,
    showMiddleName: PropTypes.bool,
    showDateOfBirth: PropTypes.bool,
    licenseHolderAsCoordinator: PropTypes.bool,
    isOrganizationContact: PropTypes.bool,
    minAgeCfg: PropTypes.number,
  }

  static defaultProps = {
    prefix: null,
    showTitle: true,
    showMiddleName: true,
  }

  render() {
    const {
      titles,
      genders,
      nationalities,
      employmentStatuses,
      isPayment,
      showTitle,
      showMiddleName,
      showDateOfBirth,
      licenseHolderAsCoordinator,
      isOrganizationContact,
      minAgeCfg,
    } = this.props

    const prefix = this.props.prefix && this.props.prefix.length > 0
      ? `${this.props.prefix}.`
      : ''

    const colClass = smWidth =>
      (!isPayment ? `col-xs-12 ${smWidth && 'col-sm-' + smWidth} col-md-4` : '')
    const rowClass = !isPayment ? 'row' : ''

    return (
      <div>
        {!licenseHolderAsCoordinator && !isPayment && showTitle &&
          <div className='row'>
            <div className='col-xs-4'>
              <Select
                name={`${prefix}title`}
                label='Title'
                intlKey='label.title'
                options={titles}
                dataTestId='titleSelector'
              />
            </div>
          </div>}
        <div className={rowClass}>
          {!licenseHolderAsCoordinator && <div className={colClass()}>
            <Input
              name={`${prefix}firstName`}
              label='First Name'
              intlKey='label.first_name'
              dataTestId='firstNameInput'
            />
          </div>}

          {!licenseHolderAsCoordinator && showMiddleName && <div className={colClass()}>
            <Input
              name={`${prefix}middleName`}
              label='Middle Name (optional)'
              intlKey='label.middle_name'
            />
          </div>}

          {!licenseHolderAsCoordinator && <div className={colClass()}>
            <Input
              name={`${prefix}lastName`}
              label='Last Name'
              intlKey='label.last_name'
              dataTestId='lastNameInput'
            />
          </div>}
        </div>

        {isOrganizationContact && minAgeCfg && !showDateOfBirth && <div className={rowClass}>
          <div className={colClass(8)}>
            <Checkbox
              name={`${prefix}minAgeConfirmation`}
              label='I confirm that I am older than {age}'
              intlKey='label.age_confirmation'
              intlValues={{
                age: (Math.round(minAgeCfg / 12)),
              }}
            />
          </div>
        </div>}

        {(!isOrganizationContact || showDateOfBirth) && <div className={rowClass}>
          <div className={colClass(8)}>
            <InputDate
              name={`${prefix}birthDate`}
              label='Birthdate'
              intlKey='label.birthdate'
              dataTestId='birthdayInput'
            />
          </div>
        </div>}

        {genders &&
          genders[0] &&
          <div className={rowClass}>
            <div className={colClass(12)}>
              <RadioGroup
                {...this.props}
                name={`${prefix}gender.value`}
                label='Gender'
                intlKey='label.gender'
                errors={this.props.errors}
                horizontal
                dataTestId='genderRadioGroup'
              >
                {genders.map(item => (
                  <Radio
                    label={item.label}
                    name={`${prefix}gender.value`}
                    value={item.value}
                    key={item.value}
                  />
                ))}
              </RadioGroup>
            </div>
          </div>}

        {nationalities &&
          <div className={rowClass}>
            <div className={colClass(6)}>
              <Select
                name={`${prefix}nationality.value`}
                label='Nationality'
                intlKey='label.nationality'
                options={nationalities}
                searchable
                dataTestId='nationalitiesSelector'
              />
            </div>
          </div>}

        {employmentStatuses &&
          <div className={rowClass}>
            <div className={colClass(6)}>
              <Select
                name={`${prefix}employmentStatus.value`}
                label='Employment Status'
                intlKey='label.employment_status'
                options={employmentStatuses}
                dataTestId='employementStatusesSelector'
              />
            </div>
          </div>}
      </div>
    )
  }
}
